

<ng-container *ngIf="!isOptionLoading;else Loading">
  <app-nav-header [CompanyID]="CompanyID" [UserID]="UserID" [Liff_ID]="Liff_ID" [title]="'剩餘點數'"></app-nav-header>  
          <form class="page__content pageForm">
            <div class="row">
              <!-- 餘額顯示 -->
              <div class="col-12 mt-2 mb-2">
                <p style="margin: 0 auto;text-align: center;font-size: 5em;font-weight: bolder;width: 300px;">{{Balance}}</p>
              </div>
              <div class="col-12 mt-2 mb-2" style="text-align: center;font-size: 1.5em;">
                <p-button label="顯示明細" styleClass="p-button-link" (onClick)="ShowDetails()"></p-button>
              </div>
            </div>
          </form>
          <p-sidebar [(visible)]="showDs" [fullScreen]="true" [baseZIndex]="10000">
            <p-accordion [multiple]="true">
              <p-accordionTab header="儲值">
                <p-table [value]="editModel.AddValues">
                  <ng-template pTemplate="header">
                      <tr>
                          <th>日期</th>
                          <th>門市</th>
                          <th>金額</th>
                      </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-addValue>
                      <tr>
                          <td>
                              {{addValue.Date | date:'yyyy/MM/dd'}}
                          </td>
                          <td>
                              <span class="image-text">{{addValue.StoreName}}</span>
                          </td>
                          <td>
                              <span class="image-text">{{addValue.Amount}}</span>
                          </td>
                      </tr>
                  </ng-template>
                </p-table>
              </p-accordionTab>
              <p-accordionTab header="消費">
                <p-table [value]="editModel.Consumptions">
                  <ng-template pTemplate="header">
                      <tr>
                          <th>日期</th>
                          <th>門市</th>
                          <th>金額</th>
                      </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-consumption>
                      <tr>
                          <td>
                              {{consumption.Date | date:'yyyy/MM/dd'}}
                          </td>
                          <td>
                              <span class="image-text">{{consumption.StoreName}}</span>
                          </td>
                          <td>
                              <span class="image-text">{{consumption.Amount}}</span>
                          </td>
                      </tr>
                  </ng-template>
                </p-table>
              </p-accordionTab>
          </p-accordion>
          </p-sidebar>           
</ng-container>
<ng-template #Loading>
<p-progressSpinner ariaLabel="loading" />
</ng-template>